<script>
    import R from "../lib/requests";
    import {clickOutside} from '../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';

    export let transporter = null;
    export let placeholder = '';

    let transporterId = null;
    let name = '';
    let timer;
    let results = [];
    let listIndex = -1;
    let showDropdown = false;
    let ignoreChanges = false;

    const dispatch = createEventDispatcher();

    const search = () => {
        const onSuccess = result => {
            results = result;
            openDropdown();
        }

        const onFailure = err => {
        };

        R.handle(R.transporter.index, {name}, onSuccess, onFailure);
    }

    const onFocusOut = () => {
        if (transporter) {
            name = transporter.name;
        }
    }

    const onKeyDown = (event) => {
        if (results && results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter') {
                event.preventDefault();
                if (timer) {
                    clearInterval(timer);
                }
                if (listIndex > -1) {
                    onSelect(results[listIndex]);
                } else {
                    closeDropdown();
                }
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        }
    }

    const onKeyUp = (event) => {
        console.log("keyup", name, event.target.value);
        if (name != event.target.value) {
            name = event.target.value;
            if (timer) {
                clearInterval(timer);
            }

            if (name.length) {
                timer = setInterval(() => {
                    clearInterval(timer);
                    search();
                }, 500);
            } else {
                clear();
            }
        }
    }

    const clear = () => {
        transporter = null;
        transporterId = null;
        dispatch("change");
    }

    const onSelect = (item) => {
        transporter = item;
        name = transporter.name;
        dispatch("change", transporter);
        closeDropdown();
    }

    const openDropdown = () => {
        showDropdown = true;
    }

    const closeDropdown = () => {
        showDropdown = false;
    }

    $: {
        if (transporter) {
            if (transporterId != transporter.id) {
                transporterId = transporter.id;
                name = transporter.name;
            }
        } else {
            if (transporterId != null && !transporter) {
                transporterId = null;
                name = '';
            }
        }
    }
</script>


<div class="dropdown-container" use:clickOutside on:click_outside="{ closeDropdown }">
    <input type="text" class="form-control" value="{ name }" on:keydown="{ onKeyDown }" on:keyup="{ onKeyUp }"
           on:focusout="{ onFocusOut }"
           {placeholder}>

    {#if showDropdown}
        {#if results.length}
            <ul class="dropdown">
                {#each results as item, index}
                    <li class="dropdown-item pointer" class:selected="{ listIndex === index }"
                        on:click="{ () => onSelect(item) }">
                        { item.name }
                    </li>
                {/each}
            </ul>
        {/if}
    {/if}
</div>